export enum HeaderName {
  IkalaBogusToken = 'ikala-bogus-token',
  IkalaTraceIp = 'ikala-trace-ip',
  EnterpriseIdentityDomain = 'x-enterprise-identity-domain',
}
